import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/3b2ebd6b-4b18-41e2-9b74-955a6cad8777.png"
              alt="クニエ合同会社"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-8">
            <Link
              to="/business"
              className={`text-sm font-medium transition-colors cursor-pointer hover:text-gray-600 ${
                isActive('/business') ? 'text-black border-b-2 border-black' : isScrolled ? 'text-gray-700' : 'text-gray-800'
              }`}
            >
              事業内容
            </Link>
            <Link
              to="/company"
              className={`text-sm font-medium transition-colors cursor-pointer hover:text-gray-600 ${
                isActive('/company') ? 'text-black border-b-2 border-black' : isScrolled ? 'text-gray-700' : 'text-gray-800'
              }`}
            >
              会社概要
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors cursor-pointer hover:text-gray-600 ${
                isActive('/contact') ? 'text-black border-b-2 border-black' : isScrolled ? 'text-gray-700' : 'text-gray-800'
              }`}
            >
              お問い合わせ
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
